import {
    SHOW_MESSAGE,
    CLOSE_MESSAGE
} from '../../actions'

const initialState = {
    show: false,
    message: undefined,
}

const snackbar = (state = initialState, action) => {
    switch (action.type) {
        case SHOW_MESSAGE:
            return {
                ...state,
                message: {
                    ...action.payload
                },
                show: true
            }
        case CLOSE_MESSAGE:
            return {
                ...state,
                show: false,
            }
        default:
            return state
    }
}

export default snackbar



// WEBPACK FOOTER //
// ./src/reducers/ui/snackbar.js